import {Component, OnInit} from '@angular/core';
import {AppAlertService,} from '../../shared/services/app-alert/app-alert.service';
import {AppAlertType} from '../../shared/services/app-alert/app-alert';

@Component({
  selector: 'app-sweet-alert',
  templateUrl: './sweet-alert.component.html',
  styleUrl: './sweet-alert.component.scss',
})
export class SweetAlertComponent implements OnInit {
  public header?: string;
  public message: string;
  public alertType: any;
  public showSweetAlert: boolean = false;
  acceptLabel?: string;
  rejectLabel?: string;
  image?: string;
  time: number;
  duration: string;
  private timer: any;
  private acceptFunction: () => void;
  private rejectFunction: () => void;

  constructor(private readonly appAlertService: AppAlertService) {
  }

  ngOnInit(): void {
    this.appAlertService.eventSource.subscribe((res) => {
      this.setType(res.alertType);
      this.header = res.header;
      this.message = res.message;
      this.acceptLabel = res.acceptLabel;
      this.rejectLabel = res.rejectLabel;
      this.image = res.image;
      this.acceptFunction = res.accept || (() => {
      });
      this.rejectFunction = res.reject || (() => {
      });

      this.time = res.time ? res.time : 5000;

      this.show();
    });
  }

  private show(): void {
    if (this.alertType === 'sweetAutoClose') {
      this.startTimer();
    }
    this.showSweetAlert = true;
  }

  private startTimer(): void {
    this.timer = setTimeout(() => {
      this.close();
    }, this.time);
  }

  close(): void {
    clearTimeout(this.timer);
    this.showSweetAlert = false;
  }

  acceptButton(event: any) {
    this.acceptFunction();
    this.showSweetAlert = false;
  }

  rejectButton(event: any) {
    this.rejectFunction();
    this.showSweetAlert = false;
  }

  private setType(alertType: AppAlertType): void {
    switch (alertType) {
      case AppAlertType.sweetError:
        this.alertType = 'sweetError';
        break;
      case AppAlertType.sweetQuestion:
        this.alertType = 'sweetQuestion';
        break;
      case AppAlertType.sweetSuccess:
        this.alertType = 'sweetSuccess';
        break;
      case AppAlertType.sweetInfo:
        this.alertType = 'sweetInfo';
        break;
      case AppAlertType.sweetWarning:
        this.alertType = 'sweetWarning';
        break;
      case AppAlertType.sweetImageMessage:
        this.alertType = 'sweetImageMessage';
        break;
      case AppAlertType.sweetConfirm:
        this.alertType = 'sweetConfirm';
        break;
      case AppAlertType.sweetInput:
        this.alertType = 'sweetInput';
        break;
      case AppAlertType.sweetAutoClose:
        this.alertType = 'sweetAutoClose';
        break;
    }
  }
}
